module.exports = __webpack_public_path__ + "img/microphone.08dbc132.png";